import { render, staticRenderFns } from "./ReservedAmountTable.vue?vue&type=template&id=55c57105&scoped=true&"
import script from "./ReservedAmountTable.vue?vue&type=script&lang=ts&"
export * from "./ReservedAmountTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReservedAmountTable.vue?vue&type=style&index=0&id=55c57105&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c57105",
  null
  
)

export default component.exports